import { Box, BoxProps } from '@mui/material'

export const BoxForm = (muiBoxProps: BoxProps): JSX.Element => (
  <Box
    {...muiBoxProps}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      ...muiBoxProps.sx,
    }}
  />
)
